import * as React from "react";

export const Import = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 2.40002C8.33127 2.40002 8.5999 2.66865 8.5999 3.00002V9.0515L10.5756 7.07576C10.81 6.84145 11.1899 6.84145 11.4242 7.07576C11.6585 7.31007 11.6585 7.68997 11.4242 7.92429L8.42417 10.9243C8.18985 11.1586 7.80995 11.1586 7.57564 10.9243L4.57564 7.92429C4.34132 7.68997 4.34132 7.31007 4.57564 7.07576C4.80995 6.84145 5.18985 6.84145 5.42417 7.07576L7.3999 9.0515V3.00002C7.3999 2.66865 7.66853 2.40002 7.9999 2.40002ZM2.3999 13C2.3999 12.6687 2.66853 12.4 2.9999 12.4H12.9999C13.3313 12.4 13.5999 12.6687 13.5999 13C13.5999 13.3314 13.3313 13.6 12.9999 13.6H2.9999C2.66853 13.6 2.3999 13.3314 2.3999 13Z"
    />
);
